import * as Popover from '@radix-ui/react-popover';
import { Check, ChevronDown, ListFilter } from 'lucide-react';
import { EngageStatusFilter } from './engage-library-types';
import { StatusFilterOption } from './engage-library-utils';
import styles from './EngageLibraryStatusFilter.module.css';

interface EngageLibraryStatusFilterProps {
  value: EngageStatusFilter;
  counts: Record<EngageStatusFilter, number>;
  options: StatusFilterOption[];
  onChange: (value: EngageStatusFilter) => void;
}

export function EngageLibraryStatusFilter({
  value,
  counts,
  options,
  onChange,
}: EngageLibraryStatusFilterProps) {
  const selectedOption = options.find(option => option.value === value);
  const triggerLabel = value === 'all' ? 'Status' : (selectedOption?.label ?? 'Status');

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button type="button" className={styles.filterButton} data-active={value !== 'all'}>
          <ListFilter className={styles.filterIcon} />
          {triggerLabel}
          <ChevronDown className={styles.caret} />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className={styles.menu} align="start" sideOffset={8}>
          {options.map(option => (
            <Popover.Close
              key={option.value}
              type="button"
              className={styles.menuOption}
              data-selected={value === option.value}
              data-status={option.value}
              onClick={() => onChange(option.value)}>
              <span className={styles.optionDot} />
              {option.label}
              <span className={styles.optionMeta}>
                {counts[option.value]}
                {value === option.value && <Check className={styles.checkIcon} />}
              </span>
            </Popover.Close>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
